/**
 * i18n key mapping for passenger category labels.
 * Keys resolve under the `search` namespace (e.g. `search:available_adult_seats`).
 */
export const PASSENGER_CATEGORY_I18N_KEYS = {
  minor: 'available_minor_seats',
  older: 'available_older_seats',
  older_half: 'available_older_half_seats',
  general: 'available_adult_seats',
  oversold: 'available_adult_seats',
  student: 'available_student_seats',
  teacher: 'available_teacher_seats',
  free_pass: 'available_free_pass_seats',
  disadvantaged_youth: 'available_disadvantaged_youth_seats',
  disadvantaged_youth_half: 'available_disadvantaged_youth_half_seats',
  disability: 'available_disability_seats',
  disability_half: 'available_disability_half_seats',
  federal_companion_free_pass: 'available_federal_companion_free_pass_seats',
  wheelchair_handicap: 'available_wheelchair_handicap_seats',
  special: 'available_special_seats',
  pet_friendly: 'available_pet_friendly_seats',
};

/**
 * Resolve the i18n key for a passenger category type.
 * @param {string} type - Canonical passenger category (e.g. `general`, `older`, `minor`).
 * @returns {string} Key within the `search` namespace.
 */
export const getPassengerCategoryI18nKey = (type) =>
  PASSENGER_CATEGORY_I18N_KEYS[type] || PASSENGER_CATEGORY_I18N_KEYS.general;
